import {
  ChakraFlex,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';

const TOP_LEVEL_ID = 'notification-counts';

interface NotificationCountsProps {
  count?: number;
  text?: string;
}

const { captionBold } = EquipUITheme.typography;
const { neutral } = EquipUIFireflyV2Theme.colors;

const NotificationCounts = ({ count, text }: NotificationCountsProps) => {
  return (
    <>
      <ChakraText id={`${TOP_LEVEL_ID}__label`}>{text}</ChakraText>
      <ChakraFlex
        {...captionBold}
        alignItems="center"
        border={`1px solid ${neutral.line}`}
        borderRadius="100px"
        color="neutral.primary"
        height="17px"
        id={`${TOP_LEVEL_ID}__count`}
        justifyContent="center"
        marginLeft="8px"
        padding="2px 8px"
      >
        {count}
      </ChakraFlex>
    </>
  );
};

export default NotificationCounts;
